import "./TimeInputPopup.scss";

import { useTheme } from "../../../hooks";

interface TimeInputPopupButtonProps {
  val: number;
  onClick: (value: string) => void;
  selected: string | null;
}
const TimeInputPopupButton = ({
  onClick,
  val,
  selected,
}: TimeInputPopupButtonProps) => {
  const theme = useTheme();
  const parsedValue = val.toString().padStart(2, "0");
  const isActive = selected === null ? false : Number(selected) === val;
  return (
    <button
      onClick={() => onClick(parsedValue)}
      className={`time_button_${theme.colorScheme} ${isActive ? "time_button_active" : ""}`}>
      {parsedValue}
    </button>
  );
};
export default TimeInputPopupButton;
